import { differenceInDays } from 'date-fns';
import { useDateNow, useReduxState } from 'hooks';
import { filterValuesSeparator } from 'shared-helpers/consts';
import { useApiData } from 'lib/api';
import { EmptyIndicator, TimeIndicator } from 'components/common';
import { Box, BoxRow } from 'components/common/box';
import { CourseProgressStatus } from 'components/common/tasks';
import { CourseTitleWithInfo } from 'components/courses/common';

const ProfileSummaryCourses = ({ isUserPage }: { isUserPage: boolean }) => {
  const { dateNow } = useDateNow();

  const {
    language,
    messages,
    pageState: { user }
  } = useReduxState();

  const { data: recentData, loading: recentLoading } = useApiData({
    url: `/admin/users/${user?.id}/recent-courses?limit=5`
  });

  const recentCourses = recentData?.recentCourses || [];

  const { data: coursesData, loading: coursesLoading } = useApiData({
    url: `/admin/users/${user?.id}/courses?limit=5&courseIds=${recentCourses
      ?.map((course) => course.id)
      ?.join(filterValuesSeparator)}`,
    onlyIf: Boolean(recentCourses?.length)
  });

  return (
    <div className="courses">
      <Box
        loading={recentLoading || (recentCourses?.length && coursesLoading)}
        padding={0}
        title={messages.profileRecentCourses}
      >
        {coursesData?.courses && coursesData.courses?.length ? (
          coursesData.courses
            .sort((a, b) =>
              recentCourses.findIndex((course) => course.id === a.id) >
              recentCourses.findIndex((course) => course.id === b.id)
                ? 1
                : -1
            )
            .map((course) => {
              const { date } =
                recentCourses.find((recent) => recent.id === course.id) || {};

              return (
                <BoxRow key={course.id}>
                  <div className="row-sm row-center">
                    <div className="col">
                      <CourseTitleWithInfo
                        course={course}
                        linkAs={
                          isUserPage
                            ? `/users/${user.id}/courses/${course.id}`
                            : `/profile/courses/${course.id}`
                        }
                        linkHref={
                          isUserPage
                            ? '/users/[userId]/courses/[courseId]'
                            : '/profile/courses/[courseId]'
                        }
                      >
                        {date ? (
                          <TimeIndicator
                            language={language}
                            relativeMode={
                              Math.abs(
                                differenceInDays(dateNow, Date.parse(date))
                              ) < 2
                            }
                            timeString={date}
                          />
                        ) : null}
                      </CourseTitleWithInfo>
                    </div>
                    <div className="col-min">
                      <CourseProgressStatus
                        course={course}
                        id={`profile-summary-courses-progress-${course.id}`}
                        progressData={course.progressData}
                      />
                    </div>
                  </div>
                </BoxRow>
              );
            })
        ) : (
          <EmptyIndicator
            description={
              isUserPage
                ? messages.profileRecentCoursesEmptyInfoUser
                : messages.profileRecentCoursesEmptyInfo
            }
            icon="book"
            size="small"
            title={messages.commonNoCourses}
          />
        )}
      </Box>
    </div>
  );
};

export default ProfileSummaryCourses;
